module.exports = __webpack_public_path__ + "img/NTAK_Home_bg.24929d5f.svg";